import { render, staticRenderFns } from "./NewEmailTemplate.vue?vue&type=template&id=f231705c&scoped=true&"
import script from "./NewEmailTemplate.vue?vue&type=script&lang=js&"
export * from "./NewEmailTemplate.vue?vue&type=script&lang=js&"
import style0 from "./NewEmailTemplate.vue?vue&type=style&index=0&id=f231705c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f231705c",
  null
  
)

export default component.exports